import { render, staticRenderFns } from "./CreditsManager.vue?vue&type=template&id=f9f80320&"
import script from "./CreditsManager.vue?vue&type=script&lang=ts&"
export * from "./CreditsManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports